import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41272eb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip_dialog" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statement" }, [
  /*#__PURE__*/_createTextVNode("可牛办公官网："),
  /*#__PURE__*/_createElementVNode("span", { class: "link" }, "o.keniu.com")
], -1))
const _hoisted_6 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconClose, {
        class: "icon_close",
        onClick: _ctx.clickClose
      }, null, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "header", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "body", {}, undefined, true),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickSelfBtn && _ctx.clickSelfBtn(...args)))
        }, "确定")
      ])
    ])
  ]))
}